<template>
  <div class="pageStyle">
    <div class="top-bg"></div>
    <div class="top-title">
      <div>
        <span>设置中心</span>
        <span>查看和管理您的账号信息</span>
      </div>
      <div>
        <img
          src="https://static.xchengtech.cn/5927dc560b8048dc87ede7a09c175670.png"
          alt=""
        />
      </div>
    </div>
    <div class="content">
      <div
        class="item"
        @click="changePasswordDialogShow = !changePasswordDialogShow"
      >
        <div class="left">
          <img
            src="https://static.xchengtech.cn/046ac645b2e441b989f9cefedd02d219.png"
            alt=""
          />
          <span>修改密码</span>
        </div>
        <div class="right">
          <img
            src="https://static.xchengtech.cn/44cb4958e144485d8f7c0e98acd920e6.png"
            alt=""
          />
        </div>
      </div>
      <div class="item" @click="loginOut">
        <div class="left">
          <img
            src="https://static.xchengtech.cn/512efb0f55b1409582542fa96b6d0941.png"
            alt=""
          />
          <span>退出登录</span>
        </div>
        <div class="right">
          <img
            src="https://static.xchengtech.cn/44cb4958e144485d8f7c0e98acd920e6.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <van-dialog
      v-model="changePasswordDialogShow"
      class="changePasswordDialogShow"
      :show-confirm-button="false"
    >
      <div class="title">修改密码</div>
      <van-field
        v-model="form.phone"
        label="手机号"
        type="tel"
        placeholder="请输入手机号"
      />
      <van-field
        v-model="form.code"
        center
        clearable
        label="短信验证码"
        placeholder="请输入验证码"
      >
        <template #button>
          <van-button @click="toGetCode" size="small" type="primary">{{
            codeTxt
          }}</van-button>
        </template>
      </van-field>
      <van-field
        v-model="form.password1"
        label="新密码"
        placeholder="请输入新密码"
      />
      <van-field
        v-model="form.password2"
        label="确认密码"
        placeholder="请再次输入新密码"
      />
      <div class="btn">
        <span @click="changePasswordCancel">取消</span>
        <span @click="changePasswordConfirm">确认</span>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import { Dialog, Field, Notify, Toast } from "vant";
import { updatePassBySmsCode } from "@/api/userCenter.js";
import { removeToken } from "@/utils/auth.js";
import { sendSms } from "@/api/login.js";
import { getToken } from "@/utils/auth.js";
import store from "@/store";
import Cookies from "js-cookie";
import router from "@/router";
import { updateChannelToken } from "@/api/login.js";
Vue.use(Dialog);
Vue.use(Field);
Vue.use(Notify);
Vue.use(Toast);
export default {
  name: "XcExhibitionSystemSet",
  data() {
    return {
      changePasswordDialogShow: false,
      form: {
        code: "",
        password1: "",
        password2: "",
        phone: "",
      },
      codeTxt: "发送验证码",
      getCodeFlag: false,
    };
  },

  mounted() {},

  methods: {
    loginOut() {
      Dialog.confirm({
        title: "提示",
        message: "确认注销登录吗?",
      })
        .then(() => {
          Toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true,
            message: "加载中",
          });
          updateChannelToken({ token: null })
            .then((res) => {
              console.log("res", res);
              Toast.clear();
              removeToken();
              router.push({
                path: "/login",
              });
            })
            .catch((err) => {
              removeToken();
              router.push({
                path: "/login",
              });
              console.log("err", err);
              Toast.clear();
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    // 验证码文本倒计时
    phoneCodeInterval() {
      let time = 60;
      this.getCodeFlag = true;
      let v = setInterval(() => {
        time = time - 1;
        this.codeTxt = time + " s " + "重新获取";
        if (time == 0) {
          clearInterval(v);
          this.getCodeFlag = false;
          this.codeTxt = "获取验证码";
        }
      }, 1000);
    },
    // 获取验证码
    toGetCode() {
      // 防止频繁点击
      if (this.getCodeFlag) return false;
      if (!this.form.phone) {
        Notify({ type: "danger", message: "请输入您的手机号" });
        return false;
      }
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      sendSms(this.form.phone)
        .then((res) => {
          Toast.clear();
          Notify({
            type: "success",
            message: "验证码已发送，请留意您的手机短信",
          });
          this.phoneCodeInterval();
        })
        .catch((err) => {
          Toast.clear();
          Notify({ type: "danger", message: "验证码发送失败" });
        });
    },
    changePasswordConfirm() {
      if (!this.form.phone) {
        Notify({ type: "danger", message: "请填写手机号" });
        return false;
      }
      if (!this.form.code) {
        Notify({ type: "danger", message: "请填写短信验证码" });
        return false;
      }
      if (!this.form.password1) {
        Notify({ type: "danger", message: "请填写新密码" });
        return false;
      }
      if (this.form.password1.length < 6) {
        Notify({ type: "danger", message: "密码长度过短，请设置六位数密码" });
        return false;
      }
      if (!this.form.password2) {
        Notify({ type: "danger", message: "请再次填写新密码" });
        return false;
      }
      if (this.form.password1 != this.form.password2) {
        Notify({ type: "danger", message: "两次密码不相同" });
        return false;
      }
      let body = {
        code: this.form.code,
        password: this.form.password2,
        phone: this.form.phone,
      };
      updatePassBySmsCode(body)
        .then((res) => {
          Notify({
            type: "success",
            message: "密码修改成功,请重新登录",
          });
          removeToken();
          router.push({
            path: "/login",
          });
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    changePasswordCancel() {
      this.form = {
        code: "",
        password1: "",
        password2: "",
        phone: "",
      };
      this.changePasswordDialogShow = false;
    },
  },
};
</script>
<style scoped src="./index.css"></style>



// WEBPACK FOOTER //
// src/view/userCenter/module/set/index.vue